import { render, staticRenderFns } from "./mktInputCpfCnpj.vue?vue&type=template&id=826f707e&"
import script from "./mktInputCpfCnpj.vue?vue&type=script&lang=js&"
export * from "./mktInputCpfCnpj.vue?vue&type=script&lang=js&"
import style0 from "./mktInputCpfCnpj.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports